import React, { useEffect, useState } from 'react';
import ReactDom from "react-dom";

import _ from 'lodash';
import cx from 'classnames';

import { AssetSearchBox } from '../searchBox';

import styles from './searchContainer.module.scss';

const SearchContainerWidgetComponent = ({ className, style, widgetProps, breakpoint, parentRef, parentProps}) => {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const properties = _.get(widgetProps, 'properties', {});
  const deviceProperties = _.get(properties, `desktop`, {});
  const horizontalColumn = _.get(parentProps, `properties.desktop.horizontalColumn`, false);

  var columnStyles = {
    ...style,
    transform: 'none',
    ...getColumnStyles(deviceProperties, horizontalColumn, breakpoint)
  }
  return (
    <div
    id={`search_container_column_${id}`}
    style={columnStyles}
    className={cx({
      [styles.searchColumnWrapper]: (horizontalColumn && breakpoint == 'desktop'),
      [styles.mobileColum]: breakpoint == 'mobile'
    })}
  >
    <div
      id={id}
      className={cx(styles.searchContainer)}
      style={{
        ...style,
        transform: 'none'
      }}
    >
        <AssetSearchBox
          className={styles.widgetWrapperStyle}
          widgetProps={widgetProps}
          breakpoint={breakpoint}
        />
    </div>
  </div>
  );
};

/**
 * Generate  column Styles
 * 
*/
function getColumnStyles(properties, horizontalColumn, breakpoint) {
  var containerStyles = {};

  if (!properties) {
    return containerStyles;
  }
  const columnAlignment = _.get(properties, `horizontalAlignment`, {
    position: 'center',
    margin: 0
  });


  var alignmentPosition = _.get(columnAlignment, 'position', 'center');
  var alignmnetMargin = _.get(columnAlignment, 'margin', 0);

  //alignment
  containerStyles['justifyContent'] = alignmentPosition;


  if(!horizontalColumn || breakpoint == 'mobile') {
    return containerStyles;
  }

  if (alignmentPosition === 'left') {
    containerStyles = {
      ...containerStyles,
      justifyContent: 'flex-start',
      paddingLeft: `${alignmnetMargin}px`
    }
  }
  else if (alignmentPosition === 'right') {
    containerStyles = {
      ...containerStyles,
      justifyContent: 'flex-end',
      paddingRight: `${alignmnetMargin}px`
    }
  }

  return containerStyles;
}


export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  var styles = {
    color: color
  };

  return styles;
}

export function getBorderStyles(value, colorRgb) {
  if (!value) {
    return null;
  }

  var styles = {};
  const topLeft = _.get(value, 'radius.topLeft', null);
  const topRight = _.get(value, 'radius.topRight', null);
  const bottomLeft = _.get(value, 'radius.bottomLeft', null);
  const bottomRight = _.get(value, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  var color = 'transparent';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  styles['borderColor'] = color;

  const borderWidthString = _.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;

  return styles;
}

const searchContainerWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'parentProps'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const SearchContainerWidget = React.memo(SearchContainerWidgetComponent, searchContainerWidgetEquals);
